import "core-js/modules/es6.object.assign";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import config from '@/config/index.js';
import { common } from '@/api/api_url';
import { getToken } from '@/libs/util';
export default {
  name: 'addUpgrade',
  data: function data() {
    var _this = this;

    return {
      dataUpload: null,
      showImgIcon: {
        license: "",
        authentication: ""
      },
      imgDemo: {},
      spinShow: false,
      headers: {
        Authorization: getToken()
      },
      upgradeUserValidate: {
        enterprise_code: [{
          required: true,
          message: '企业编码不能为空',
          trigger: 'change'
        }, {
          message: '请输入6位企业编码',
          len: 6,
          trigger: 'change'
        }],
        enterprise_name: [{
          required: true,
          message: this.$t('upgrage.companyNameMess'),
          trigger: 'blur'
        }],
        enterprise_redit_code: [{
          required: true,
          message: this.$t('upgrage.enterpriseReditCodeplaceholder'),
          trigger: 'blur'
        }],
        legan_name: [{
          required: true,
          message: this.$t('upgrage.leganNameplaceholder'),
          trigger: 'blur'
        }],
        business_license: [{
          required: true,
          message: this.$t('upgrage.businessLicenseMess'),
          trigger: 'blur'
        }],
        area: [{
          required: true,
          message: this.$t('upgrage.selectAreaholder'),
          validator: function validator(rule, value, callback) {
            var data = _this.upgradeUser.area;

            if (data.length == 0) {
              callback(new Error(_this.$t('upgrage.selectAreaholder')));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        contact_name: [{
          required: true,
          message: this.$t('upgrage.contactPersonPreaholder'),
          trigger: 'blur'
        }],
        contact_tel: [{
          required: true,
          message: this.$t('upgrage.contactTelMess'),
          trigger: 'blur'
        }],
        email: [{
          required: true,
          message: this.$t('base.emailplaceholder'),
          trigger: 'blur'
        }],
        authentication: [{
          required: true,
          message: this.$t('upgrage.uploadFileMess'),
          trigger: 'blur'
        }]
      },
      upgradeUser: {
        enterprise_name: "",
        enterprise_redit_code: "",
        legan_name: "",
        business_license: "",
        area: [],
        contact_name: "",
        contact_tel: "",
        email: "",
        remark: "",
        authentication: "" // enterprise_code:'',

      }
    };
  },
  props: {
    TreeData: {}
  },
  computed: {
    fileAction: function fileAction() {
      var result = '';

      if (process.env.NODE_ENV === 'development') {
        result = config.showImg.dev + "" + common.UploadFile;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        result = config.showImg.pro + "" + common.UploadFile;
      } else {
        result = config.showImg.alp + "" + common.UploadFile;
      }

      return result;
    },
    fileActions: function fileActions() {
      var result = '';

      if (process.env.NODE_ENV === 'development') {
        result = config.showImg.dev + "" + common.uploadfiles;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        result = config.showImg.pro + "" + common.uploadfiles;
      } else {
        result = config.showImg.alp + "" + common.uploadfiles;
      }

      return result;
    },
    //文件访问前缀
    getRoot: function getRoot() {
      var root = config.showImg.pro;

      if (process.env.NODE_ENV === 'development') {
        root = config.showImg.dev;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        root = config.showImg.pro;
      } else {
        root = config.showImg.alp;
      }

      return root;
    },
    getUserInfo: function getUserInfo() {
      return this.$store.state.user.userInfo;
    }
  },
  methods: {
    //下载链接
    downloadUrl: function downloadUrl(url) {
      window.open(url);
    },
    formatBit: function formatBit(val) {
      val = +val;
      return val > 9 ? val : '0' + val;
    },
    // 秒转时分秒，求模很重要，数字的下舍入
    formatSeconds: function formatSeconds(time) {
      var min = Math.floor(time % 3600);
      return this.countdown = this.formatBit(Math.floor(time / 3600)) + ':' + this.formatBit(Math.floor(min / 60)) + ':' + this.formatBit(time % 60);
    },
    // 定时器
    minReturn: function minReturn(time) {
      var vm = this;
      var t = setInterval(function () {
        time--;
        vm.formatSeconds(time);

        if (time <= 0) {
          clearInterval(t);
        }
      }, 1000);
    },
    init: function init() {
      var _this2 = this;

      this.$store.dispatch("handleenterprise_audit_count_down", {}).then(function (res) {
        if (res.result === 0) {
          var status = res.body.status; //0为未提交企业认证，，1为等待审核，2为审核通过，3为审核失败

          _this2.status = status;

          if (status === 0) {
            _this2.current = 0;
          } else {
            _this2.current = 2;

            if (_this2.status === 1) {
              var count_down = res.body.count_down;

              if (count_down == '0') {
                _this2.countdown = '00:00:00';
              } else {
                _this2.minReturn(count_down);
              }
            }

            _this2.enterprise_name = res.body.enterprise_name;
            _this2.enterprise_audit_desc = res.body.enterprise_audit_desc;
          }
        } else {
          _this2.$Message.error(res.errorMsg);
        }
      });
    },
    handleFormatError: function handleFormatError(file) {
      this.spinShow = false;
      this.$Notice.warning({
        title: this.$t('productModule.uploadFileFormatTitle'),
        desc: this.$t('productModule.uploadFileFormatTitleDesc')
      });
    },
    handleFormatError1: function handleFormatError1(file) {
      this.spinShow = false;
      this.$Notice.warning({
        title: this.$t('productModule.uploadFileFormatTitle'),
        desc: this.$t('upgrage.uploadFileFormatDocMess')
      });
    },
    handleMaxSize: function handleMaxSize(file) {
      this.spinShow = false;
      this.$Notice.warning({
        title: this.$t('upgrage.maxFileTitle'),
        desc: this.$t('upgrage.maxFileTitleMess')
      });
    },
    handleBeforeUpload: function handleBeforeUpload() {
      this.spinShow = true;
      return true;
    },
    handleBeforeUpload1: function handleBeforeUpload1() {
      this.spinShow = true;
      return true;
    },
    handleView: function handleView(name) {
      this.currSelectImg = name;
      this.visible = true;
    },
    handleRemove: function handleRemove(file) {
      ;
      this.$set(this.showImgIcon, file, null);

      if (file == 'hand_idcard') {
        this.$set(this.upgradeUser, 'hand_idcard', null);
      } else if (file == 'back_idcard') {
        this.$set(this.upgradeUser, 'back_idcard', null);
      } else if (file == 'license') {
        this.$set(this.upgradeUser, 'license', null);
      }
    },
    handleSuccess: function handleSuccess(res, file) {
      this.spinShow = false;

      if (res.result === 0) {
        this.$set(this.showImgIcon, 'license', this.getRoot + "" + res.body);
        this.$set(this.upgradeUser, 'business_license', res.body);
      } else {
        this.$set(this.showImgIcon, 'license', null);
        this.$set(this.upgradeUser, 'business_license', null);
      }
    },
    handleSuccess1: function handleSuccess1(res, file) {
      /*body: {firmware_url: "/uploads_sdk/20191027/281474d265cd567cb3d139b070036d3a.docx",…}
      firmware_url: "/uploads_sdk/20191027/281474d265cd567cb3d139b070036d3a.docx"
      md5: "5315aceb1506fe4dd29174fd22a108c1"*/
      this.spinShow = false;

      if (res.result === 0) {
        this.$set(this.showImgIcon, 'authentication', this.getRoot + "" + res.body.firmware_url);
        this.$set(this.upgradeUser, 'authentication', res.body.firmware_url);
      } else {
        this.$set(this.showImgIcon, 'authentication', null);
        this.$set(this.upgradeUser, 'authentication', null);
      }
    },
    downloadWord: function downloadWord() {
      var url = this.getUserInfo.rz_tpl_url;
      window.open(url);
    },
    //跳转到确认认证页面
    goSubmitStep: function goSubmitStep() {
      var vm = this;
      return new Promise(function (resolve, reject) {
        vm.$refs.upgradeUser.validate(function (valid) {
          if (valid) {
            resolve(vm.upgradeUser);
          } else {
            reject(valid);
          }
        });
      });
    },
    backLastStep: function backLastStep() {
      this.current = 0;
    },
    resetAuthener: function resetAuthener() {
      this.current = 0;
    },

    /**
     * 上一步需要回填的数据
     */
    backData: function backData(obj) {
      Object.assign(this.upgradeUser, obj);
      this.$set(this.showImgIcon, "license", this.getRoot + "" + this.upgradeUser.business_license);
      this.$set(this.showImgIcon, "authentication", this.upgradeUser.authentication);
    }
  }
};